import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';

function AnnouncementBar(_ref) {
  let {
    children,
    onDismiss,
    margin,
    className
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "onDismiss", "margin", "className"]);

  let cssClasses = ['st_announcement-bar'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cssClasses.join(' '),
    role: "alert"
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "st_announcement-bar__content"
  }, children), /*#__PURE__*/React.createElement("button", {
    className: "st_announcement-bar__button",
    onClick: onDismiss,
    type: "button",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "cross",
    size: "mlg"
  })));
}

AnnouncementBar.propTypes = {
  /** callback when announcement is dismissed */
  onDismiss: PropTypes.func.isRequired,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** margin for component, if any */
  margin: marginProps
};
AnnouncementBar.defaultProps = {
  className: null,
  margin: null
};

export default AnnouncementBar;
